import React from 'react';
import { observer } from 'mobx-react';
import { useAITTheme } from '@this/src/components/shared/ui/theme';

const OrderItemStepSection: React.FC = ({ children }) => {
  const { theme } = useAITTheme();

  return (
    <div
      style={{
        paddingBottom: '8px',
        marginBottom: '8px',
        borderBottom: `1px solid ${theme.tokens.colors.border.divider}`
      }}
    >
      {children}
    </div>
  );
};

export default observer(OrderItemStepSection);
